document.addEventListener("DOMContentLoaded", function () {
  function initFooterAccordions() {
    if (window.innerWidth <= 749) {
      const headings = document.querySelectorAll(".footer-new__link-heading");
      // console.log("🚀 ~ initFooterAccordions ~ headings:", headings);

      headings.forEach((heading) => {
        // Remove existing listeners to prevent duplicates
        const newHeading = heading.cloneNode(true);
        heading.parentNode.replaceChild(newHeading, heading);

        newHeading.addEventListener("click", function (e) {
          // console.log("🚀 ~ initFooterAccordions ~ newHeading:", newHeading);

          e.preventDefault();
          const column = this.closest(".footer-new__link-column");

          // Close other accordions
          document
            .querySelectorAll(".footer-new__link-column")
            .forEach((col) => {
              if (col !== column) {
                col.classList.remove("is-open");
              }
            });

          // Toggle current accordion
          column.classList.toggle("is-open");
        });
      });
    }
  }

  // Initialize on load
  initFooterAccordions();

  // Re-initialize on resize
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initFooterAccordions, 250);
  });
});
